import { styled } from '@mui/material';

import type { IconLayoutProps } from './IconLayout.types';

export const IconLayout = ({
  startIcon,
  endIcon,
  children,
}: IconLayoutProps) => {
  return (
    <>
      {startIcon && <StartIconRoot aria-hidden>{startIcon}</StartIconRoot>}
      {children}
      {endIcon && <EndIconRoot aria-hidden>{endIcon}</EndIconRoot>}
    </>
  );
};

const StartIconRoot = styled('span')(({ theme }) => ({
  display: 'inherit',
  marginRight: theme.spacing(2),
}));

const EndIconRoot = styled('span')(({ theme }) => ({
  display: 'inherit',
  marginLeft: theme.spacing(3),
}));
